import React, { Component } from 'react';

//componentes
import SubirCurriculum from './subirCurriculum'

class Index extends Component {

    render(){
        return(
            <div>
                <SubirCurriculum />
            </div>
        );
    }

}
export default Index;